import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./NovoUsuario.module.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import UsuarioApi from "../../services/UsuarioApi";
import GrupoDeUsuarioApi from "../../services/GrupoDeUsuarioApi";
import Alerta from "../../components/alerta/Alerta";
import BotaoSalvar from "../../components/botaoSalvar/BotaoSalvar";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function NovoUsuario() {
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);

  const [nomeCompleto, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [grupoDeUsuario, setGrupoDeUsuario] = useState("");
  const [grupoDeUsuarios, setGrupoDeUsuarios] = useState([]);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");
  const [loading, setLoading] = useState(false);
  const [clicou, setClicou] = useState(false);

  const navigate = useNavigate();

  const exibirAlerta = (mensagem, tipo) => {
    setMensagemAlerta(mensagem);
    setTipoAlerta(tipo);
    setMostrarAlerta(true);

    setTimeout(() => {
      setMostrarAlerta(false);
      if (tipo === "success") {
        navigate("/");
      }
    }, 1000);
  };

  useEffect(() => {
    const fetchGrupoDeUsuarios = async () => {
      try {
        const grupos = await GrupoDeUsuarioApi.ListarGrupoDeUsuarioAsync(true);
        setGrupoDeUsuarios(grupos);
      } catch (error) {
        console.error("Erro ao buscar grupo de usuários:", error.response.data);
      }
    };
    fetchGrupoDeUsuarios();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isFormValid()) {
        setClicou(true);
        setLoading(true);
        await UsuarioApi.AdicionarUsuarioAsync(
          nomeCompleto,
          email,
          grupoDeUsuario
        );
        exibirAlerta("Usuário adicionado com sucesso!", "success");
      } else {
        exibirAlerta("Por favor, preencha todos os campos.", "warning");
      }
    } catch (error) {
      exibirAlerta(
        `Erro ao adicionar usuário: ${error.response.data}`,
        "danger"
      );
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = () => {
    return (
      nomeCompleto && email && grupoDeUsuario
    );
  };

  return (
    <Sidebar 
    setMenuHamburguerAberto={setMenuHamburguerAberto}
    menuHamburguerAberto={menuHamburguerAberto}>
      <Topbar
        menuHamburguerAberto={menuHamburguerAberto}
        setMenuHamburguerAberto={setMenuHamburguerAberto}
      >
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        {loading && <Loader />}
        <div className={style.pagina_conteudo}>
          <h4>Novo Usuário</h4>

          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formNomeCompleto" className="mb-3">
              <Form.Label>Nome Completo</Form.Label>
              <InputBuscar
                maxLength={100}
                type="text"
                placeholder="Digite seu nome completo"
                name="nomeComleto"
                value={nomeCompleto}
                onChange={(e) => setNome(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formEmail" className="mb-3">
              <Form.Label>Email</Form.Label>
              <InputBuscar
                maxLength={100}
                type="email"
                placeholder="Digite seu email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formGrupoDeUsuario" className="mb-3">
              <Form.Label>Grupo de Usuário</Form.Label>
              <Form.Control
                as="select"
                name="GrupoDeUsuario"
                value={grupoDeUsuario}
                onChange={(e) => setGrupoDeUsuario(e.target.value)}
                required
              >
                <option value="">Selecione o grupo de usuário</option>
                {grupoDeUsuarios.map((grupo) => (
                  <option key={grupo.id} value={grupo.id}>
                    {grupo.nome}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <BotaoSalvar isDisabled={!isFormValid() || clicou} />
          </Form>
        </div>
      </Topbar>
    </Sidebar>
  );
}

export default NovoUsuario;
